import { useMemo, useState } from "react";
import { Transaction, TransactionType } from "../../../models";
import { ColumnDef } from "@tanstack/react-table";
import { useData } from "../../../utils/useData";
import { TransactionDirection } from "../../../models/transactions/transactionDirection";
import { Table } from "../../shared/Table";
import { IconButton } from "@mui/material";
import { SideDrawer } from "../../shared/SideDrawer";
import { RewardsSentTableDrawer } from "./RewardsSentTableDrawer";
import { formatCurrency, formatDate } from "../../../utils/formatters";
import { MoreHorizontal } from "react-feather";

export const RewardsSentTable = () => {

    const { transactions } = useData();

    const rewardTxns = useMemo(() => {
        if(!transactions.data || !transactions.data.items){
            return [];
        }

        return transactions.data.items.filter((txn) => 
            txn.type === TransactionType.PAYMENT &&
            txn.attributes?.direction === TransactionDirection.OUTGOING
        );
    }, [transactions.data])

    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedReward, setSelectedReward] = useState<Transaction | null>(null);

    
    const columns: ColumnDef<Transaction>[] = [
        {
            header: "Date",
            accessorFn: (row) => formatDate(row.createdAt),
        },
        {
            header: "Amount",
            accessorFn: (row) => formatCurrency(row.transactionAmount.amount),
        },
        {
            header: "Sender",
            accessorFn: (row) => `${row.paymentInfo?.sender.firstName} ${row.paymentInfo?.sender.lastName}`,
        },
        {
            header: "Receiver",
            accessorFn: (row) => `${row.paymentInfo?.receiver.firstName} ${row.paymentInfo?.receiver.lastName}`,
        },
        {
            header: "Info",
            cell: ({row}) => {
                return (
                    <IconButton onClick={() => {
                        setSelectedReward(row.original);
                        setOpenDrawer(true);
                    }}>
                        <MoreHorizontal />
                    </IconButton>
                )
            },
        }
    ]

    
    return (
        <div>
            <h1>Rewards Sent</h1>
            <Table<Transaction>
                data={rewardTxns}
                columns={columns}
                totalItems={rewardTxns.length}
                rowSelection={false}
                displayFilters={false}
                displaySearch={true}
            />
                <RewardsSentTableDrawer
                    open={openDrawer}
                    setIsOpen={setOpenDrawer}
                    rewardPayment={selectedReward} 
                />
        </div>
    )
}